import React from 'react';
import { st, classes } from './ProgressiveBlur.st.css';

const BLUR_LAYER_COUNT = 7;

export type ProgressiveBlurSide = 'left' | 'right' | 'start' | 'end';

export interface ProgressiveBlurProps {
  side: ProgressiveBlurSide;
  className?: string;
}

const ProgressiveBlur = ({ side, className }: ProgressiveBlurProps) => (
  <span className={st(classes.root, { side }, className)} aria-hidden="true">
    {Array.from({ length: BLUR_LAYER_COUNT }, (_, index) => (
      <span key={index} className={classes.blurLayer} />
    ))}
  </span>
);

ProgressiveBlur.displayName = 'ProgressiveBlur';

export { ProgressiveBlur };
